import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SessionsService } from '../common/services/sessions.service';
import { Router,ActivatedRoute } from '@angular/router';
import { FormGroup,FormControl,Validators } from '@angular/forms';
import {HttpserviceService} from '../common/services/httpservice.service';
import {retry} from 'rxjs/operators';
import {UtilsService} from '../common/services/utils.service';
import {ConstantsService} from '../common/services/constants.service';
import { Ng2ImgMaxService } from 'ng2-img-max';
import * as $ from 'jquery';
import xml2js from 'xml2js';
declare var show_okshan_alert: Function;
declare var show_okshan_alert3: Function;
declare var manage_show_hide_inspection_detail: Function;
declare var set_min_date: Function;
declare var set_max_date: Function;
declare var slide_up: Function;

@Component({
  selector: 'app-inspection-detail',
  templateUrl: './inspection-detail.component.html',
  styleUrls: ['./inspection-detail.component.css']
})
export class InspectionDetailComponent implements OnInit {
  
  carId;
  loginFormGroup2;
  sessionProfileType:number=-1;
  actionStatus:boolean=false;
  inspectionEditStatus:boolean=false;
  fuelTypeList=[];
  stateList=[];
  preferredStateList=[];
  otherStateList=[];
  bodyTypetList=[];
  highlights=[];
  keysList=[{id:"1",name:"Keys"},{id:"2",name:"Keyless"}];
  transmissionTypeList=[{id:"1",name:"AMT"},{id:"2",name:"Automatic"},{id:"3",name:"Manual"}];
  ownerTypeList=[{id:"1",name:"1st"},{id:"2",name:"2nd"},{id:"3",name:"3rd"},{id:"3",name:"3+"}];
  insuranceTypeList=[{id:"1",name:"Comp"},{id:"2",name:"ThirdParty"},{id:"3",name:"Zero Depreciation"},{id:"4",name:"Nil"}];
  rcAvailabilityList=[{id:"1",name:"Yes"},{id:"2",name:"No"},{id:"3",name:"Original"},{id:"4",name:"Duplicate"}];
  rcConditionList=[{id:"1",name:"Excellent"},{id:"2",name:"Good"},{id:"3",name:"Fair"},{id:"4",name:"Poor"},{id:"5",name:"Okay"}];
  roadTaxTypeList=[{id:"1",name:"Lifetime"},{id:"2",name:"Annual"},{id:"3",name:"N/a"}];
  roadTaxPaidList=[{id:"1",name:"Yes"},{id:"2",name:"No"}];
  rTONOCIssuedList=[{id:"1",name:"Yes"},{id:"2",name:"No"}];
  underHypothecationList=[{id:"1",name:"Yes"},{id:"2",name:"No"},{id:"3",name:"Okay"}];
  duplicateKeyList=[{id:"1",name:"Yes"},{id:"2",name:"No"}];
  odometerTamperedList=[{id:"1",name:"Yes"},{id:"2",name:"No"}];
  cNGLPGFitmentList=[{id:"1",name:"CNG"},{id:"2",name:"LPG"},{id:"3",name:"N/a"}];
  emissionList=[{id:"1",name:"Non-Euro"},{id:"2",name:"Euro I"},{id:"3",name:"Euro II"},{id:"4",name:"Euro III"},{id:"5",name:"Euro IV"},{id:"6",name:"Euro V"},{id:"7",name:"Euro VI"}];
  mismatchInsuranceList=[{id:"1",name:"Yes"},{id:"2",name:"No"},{id:"3",name:"Okay"}];
  
  basicInfoBodyTypeModel;  
  basicInfoFuelTypeModel;
  docRtoModel;

  basicInfoFormGroup;
  basicInfoSaveBtnLbl:string="Save";
  isBasicInfoSubmit:boolean=false;

  docInfoFormGroup;
  docInfoSaveBtnLbl:string="Save";
  isDocInfoSubmit:boolean=false; 

  
  exteriorInfoSaveBtnLbl:string="Save";
  isExteriorInfoSubmit:boolean=false; 
  exteriorFrontDynamicFormGroup;
  exteriorFrontFromStatus:boolean=false;
  exteriorFrontDynamicImages={};
  exteriorFrontXML;

  exteriorOtherInfoSaveBtnLbl:string="Save";
  isExteriorOtherInfoSubmit:boolean=false;
  exteriorOtherDynamicFormGroup;
  exteriorOtherFromStatus:boolean=false;
  exteriorOtherDynamicImages={};
  exteriorOtherXML;

  tyresInfoSaveBtnLbl:string="Save";
  isTyresInfoSubmit:boolean=false;
  tyresDynamicFormGroup;
  tyresFromStatus:boolean=false;
  tyresDynamicImages={};
  tyresXML;

  engineInfoSaveBtnLbl:string="Save";
  isEngineInfoSubmit:boolean=false;
  engineDynamicFormGroup;
  engineFromStatus:boolean=false;
  engineDynamicImages={};
  engineXML;  

  interiorInfoSaveBtnLbl:string="Save";
  isInteriorInfoSubmit:boolean=false;
  interiorDynamicFormGroup;
  interiorFromStatus:boolean=false;
  interiorDynamicImages={};
  interiorXML;

  aCInfoSaveBtnLbl:string="Save";
  isACInfoSubmit:boolean=false;
  aCDynamicFormGroup;
  aCFromStatus:boolean=false;
  aCDynamicImages={};
  aCXML;

  sSBInfoSaveBtnLbl:string="Save";
  isSSBInfoSubmit:boolean=false;
  sSBDynamicFormGroup;
  sSBFromStatus:boolean=false;
  sSBDynamicImages={};
  sSBXML;

  coolingSystemInfoSaveBtnLbl:string="Save";
  isCoolingSystemInfoSubmit:boolean=false;
  coolingSystemDynamicFormGroup;
  coolingSystemFromStatus:boolean=false;
  coolingSystemDynamicImages={};
  coolingSystemXML;


  documentInfoSaveBtnLbl:string="Save";
  isDocumentInfoSubmit:boolean=false;
  documentDynamicFormGroup;
  documentFromStatus:boolean=false;
  documentDynamicImages={};
  documentXML;
  
  ratingInfoSaveBtnLbl:string="Save";
  isRatingInfoSubmit:boolean=false;
  ratingExteriorTyres:number=0;
  ratingEngineTransmission:number=0;
  ratingAirCondition:number=0;
  ratingElectricalsInteriors:number=0;
  ratingSteeringSuspensionBrakes:number=0;

  fileUrl:string="";

  registrationNo:string="";
  manufacturingYear:string="";
  engineSoundVideo:string="";
  brandNameBasic:string="";
  modelNameBasic:string="";
  uidNameBasic:string="";
  rtoNameBasic:string="";
  firstNameBasic:string="";
  lastNameBasic:string="";
  AddressBasic:string="";
  cityBasic:any='';
  stateBasic:any='';
  pic1Basic:any='';
  pic2Basic:any='';
  pic3Basic:any='';
  pic4Basic:any='';
  pic5Basic:any='';
  pic6Basic:any='';
  pic7Basic:any='';
  postalBasic:string="";
  emailBasic:string="";
  phoneBasic:string="";
  rCExpiryBasic:string="";
  variantBasic:any='';
  fmvBasic:any='';

  exteriorTyres:any=0;
  engineTransmission:any=0;
  airConditioning:any=0;
  electricalsInteriors:any=0;
  steeringSuspensionBrakes:any=0;

  otherInspectionFormGroup;
  otherInspectionInfoSaveBtnLbl:string="Save";
  isOtherInspectionInfoSubmit:boolean=false; 
  otherInspectionEngineSoundVideoFile="";
  otherEngineSoundVideo="";
  selectedProfilePic;
  p1;
  p2;
  p3;
  p4;
  p5;
  p6;
  p7;
  tp;

 constructor(private sessionsService:SessionsService,private router:Router,
  private httpserviceService:HttpserviceService,
  private utilsService:UtilsService,
  private route:ActivatedRoute,
  private _constant: ConstantsService,
  private ng2ImgMaxService: Ng2ImgMaxService) { }

  ngOnInit(): void {
      if(this.sessionsService.getSession("login_status")==null)
    {       
         window.location.href="#/visitor";       
    }
    else if(!this.sessionsService.getSession("login_status"))
       {
         window.location.href="#/visitor";
       }
    window.scrollTo(0, 0);
    if(this.sessionsService.getSession("profile_type")!=null)
    {
       this.sessionProfileType=this.sessionsService.getSession("profile_type");
    }
    if(this.sessionsService.getSession("profile_type")!=null && this.sessionsService.getSession("status")!=null)
    {
       if(this.sessionsService.getSession("profile_type")!=-1 && this.sessionsService.getSession("status")==1)
       {
         this.actionStatus=true;
       }
    }
    if(!this.actionStatus || (this.sessionProfileType!=1 && this.sessionProfileType!=2))
    {
      show_okshan_alert("You don't have access of this page");
      this.router.navigate(['home']);      
    }

    if(this.sessionsService.getSession("state_list")!=null)
    {
      this.stateList=this.sessionsService.getSession("state_list");

      for(let i=0;i<this.stateList.length;i++)
        {
          if(this.stateList[i].preferred==1)
          {
            this.preferredStateList.push(this.stateList[i]);
          }
          else
          {
            this.otherStateList.push(this.stateList[i]);
          }
        }
    }

    this.carId=this.route.snapshot.queryParamMap.get('id');

    this.basicInfoFormGroup = new FormGroup(
      {
        basicInfoRCExpiry: new FormControl(''),
        basicInfoMileage: new FormControl(''),     
        basicInfoVin: new FormControl(''),
        basicInfoKeys: new FormControl(''),
        basicInfoFuelType: new FormControl(''), 
        basicInfoDocCharges: new FormControl(''), 
        basicInfoSeating: new FormControl(''),
        basicInfoKMDriven: new FormControl(''),
        basicInfoEngineDisplacement: new FormControl(''),
        basicInfoMaxTorque: new FormControl(''),
        basicInfoBootSpace: new FormControl(''),
        basicInfoMaxPower: new FormControl(''),
        basicInfoFuelTankCapacity: new FormControl(''),
        basicInfoBodyType: new FormControl(''),
        basicInfoTransmissionType: new FormControl(''),          
      } 
      )

      this.docInfoFormGroup = new FormGroup(
      {
        docChasisNo: new FormControl(''),
        docCngLpgFitment: new FormControl(''),
        docEmission: new FormControl(''),
        docRegDate: new FormControl(''),
        docInsuranceType: new FormControl(''),    
        docOwnerType: new FormControl(''),
        docInsuranceExpiryDate: new FormControl(''),
        docMismatchInsurance: new FormControl(''),
        docDetail: new FormControl(''),
        docNoClaimBonus: new FormControl(''),
        docNoClaimBonusPercent: new FormControl(''),
        docFitnessUpto: new FormControl(''),
        docRcAvailability: new FormControl(''),
        docRcCondition: new FormControl(''),
        docDetail1: new FormControl(''),
        docRto: new FormControl(''),
        docPartipeshiRequest: new FormControl(''),
        docDetail2: new FormControl(''),
        docRoadTaxType: new FormControl(''),
        docRoadTaxPaid: new FormControl(''),
        docRtoNocIssued: new FormControl(''),
        docUnderHypothecation: new FormControl(''),
        docBank: new FormControl(''),
        docDetail3: new FormControl(''),
        docDuplicateKey: new FormControl(''),
        docDetail4: new FormControl(''),
        docOdometerTampered: new FormControl(''),
        docDetail5: new FormControl(''),
      }
      )      

    this.exteriorFrontDynamicFormGroup = new FormGroup(
      {        
      }
    )

    this.exteriorOtherDynamicFormGroup = new FormGroup(
      {        
      }
    )

    this.tyresDynamicFormGroup = new FormGroup(
      {        
      }
    )

    this.engineDynamicFormGroup = new FormGroup(
      {        
      }
    ) 

    this.interiorDynamicFormGroup = new FormGroup(
      {        
      }
    )

    this.aCDynamicFormGroup = new FormGroup(
      {        
      }
    )

    this.sSBDynamicFormGroup = new FormGroup(
      {        
      }
    ) 

    this.documentDynamicFormGroup = new FormGroup(
      {        
      }
    )   

    this.otherInspectionFormGroup = new FormGroup(
      {
        //otherExterior: new FormControl(''),
        //otherTyres: new FormControl(''),
        //otherEngine: new FormControl(''),
        //otherAc: new FormControl(''),
        //otherInterior: new FormControl(''),
        //otherSSB: new FormControl(''),
        //otherBattery: new FormControl(''),
        //otherBatteryYear: new FormControl(''),
        //otherBatteryMake: new FormControl(''),
        otherEngineSoundVideo: new FormControl('')
      } 
    )

    this.coolingSystemDynamicFormGroup = new FormGroup(
      {        
      }
    ) 

    this.fileUrl=this._constant.uploadFileUrl;

    setTimeout(() => {
      this.loadExteriorFrontXML();
      this.loadExteriorOtherXML();
      this.loadTyresXML();
      this.loadEngineXML();
      this.loadInteriorXML();
      this.loadACXML();
      this.loadSSBXML();
      this.loadDocumentXML();
      this.loadCoolingSystemXML();
      manage_show_hide_inspection_detail();
      set_max_date('reg_date');
      //set_min_date('insurance_expiry_date');
      set_max_date('exterior_date');
      this.getFuelTypeList();
      this.getCarBodyType();
    }, 50);
    setTimeout(() => {
      this.getInspectionDetail();
    }, 500);    
  }

   /** saveBasicInfo function used to save basic info */
  saveBasicInfo(data)
  {
    this.isBasicInfoSubmit=true;  
    //if(this.basicInfoFormGroup.valid)
    { 
     this.basicInfoSaveBtnLbl="Saving";
     let rcExpiry:string="";
     if(data.basicInfoRCExpiry!=null)
     {
      rcExpiry=data.basicInfoRCExpiry;
     }
     let body = { profile_id: this.sessionsService.getSession('id'),car_id:this.carId,mileage:data.basicInfoMileage,registration_expiry_date:rcExpiry,
     vin:data.basicInfoVin,Keys_Keyless:data.basicInfoKeys.join(','),car_fuel_type_id:data.basicInfoFuelType.join(','),     
     seating:data.basicInfoSeating,KM_driven:data.basicInfoKMDriven,engine_displacement:data.basicInfoEngineDisplacement,max_torque:data.basicInfoMaxTorque,
     boot_space:data.basicInfoBootSpace,max_power:data.basicInfoMaxPower,fuel_tank_capacity:data.basicInfoFuelTankCapacity,body_type:data.basicInfoBodyType.join(','),transmissiontype:data.basicInfoTransmissionType.join(',')};
     let result =this.httpserviceService.saveInspectionBasicInfoRequest(body).
     pipe(retry(0)).
     subscribe((data)=>this.saveInspectionBasicInfoResponse(data),
     err => {
       this.basicInfoSaveBtnLbl="Save";
       show_okshan_alert3("Something went wrong !");
       console.log('Something went wrong ', err);       
    })       
  }
  }

  

  /** saveInspectionBasicInfoResponse methos used to handle response */
  saveInspectionBasicInfoResponse(response)
  {
    console.log('saveInspectionBasicInfoResponse '+ response.status);
    if(response.status==="success")  
     {
       this.basicInfoSaveBtnLbl="Save";
       slide_up(".inspection-heading");
       show_okshan_alert3("Basic information is saved");
     }
     else
     {
     this.basicInfoSaveBtnLbl="Save";  
     show_okshan_alert3(response.reason);     
     } 
  }

  /** getFuelTypeList function used to get fuel type list */ 
  getFuelTypeList()
  { 
    let result =this.httpserviceService.getFuelTypeListRequest().
     pipe(retry(0)).
     subscribe((data)=>this.getFuelTypeListResponse(data),
     err => {
      //  this.isRequestInprocess=false; 
        show_okshan_alert3("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
  }  

  /** getBrandWithCountResponse function used to handle response */
  getFuelTypeListResponse(response)
  {    
    console.log('getBrandWithCountResponse '+ response.status);
    if(response.status==="success")  
     { 
       this.fuelTypeList=response.list1;            
     }
     else
     {
     show_okshan_alert3(response.reason);     
     } 
  }

  /** saveDocDetail function used to save documents detail */
  saveDocDetail(data)
  {
    this.isDocInfoSubmit=true;    
    //if(this.docInfoFormGroup.valid)
    { 
     this.docInfoSaveBtnLbl="Saving";
     let body = { profile_id: this.sessionsService.getSession('id'),car_id:this.carId,chasis_no:data.docChasisNo,fitment:data.docCngLpgFitment.join(','),emission:data.docEmission.join(','),
     registration_date:data.docRegDate,owner_detail:data.docOwnerType.join(','),insurance_type:data.docInsuranceType.join(','),insurance_type_id:data.docInsuranceType.join(','),insurance_expiry_date:data.docInsuranceExpiryDate,insurance_mismatch:data.docMismatchInsurance.join(','),
     insurance_detail:data.docDetail,no_claim_bonus:data.docNoClaimBonus,no_claim_bonus_percent:data.docNoClaimBonusPercent,fitness_upto:data.docFitnessUpto,rc_availability:data.docRcAvailability.join(','),
     rc_condition:data.docRcCondition.join(','),rc_detail:data.docDetail1,rto:data.docRto.join(','),partipeshi_request:data.docPartipeshiRequest,rto_detail:data.docDetail2,road_tax_type:data.docRoadTaxType.join(','),road_tax_paid:data.docRoadTaxPaid.join(','),
     rto_noc_issued:data.docRtoNocIssued.join(','),under_hypothecation:data.docUnderHypothecation.join(','),bank:data.docBank,tax_detail:data.docDetail3,duplicate_key:data.docDuplicateKey.join(','),duplicate_key_detail:data.docDetail4,
     odometer_tampered:data.docOdometerTampered.join(','),odometer_detail:data.docDetail5};
     let result =this.httpserviceService.saveInspectionDocDetailRequest(body).
     pipe(retry(0)).
     subscribe((data)=>this.saveInspectionDocDetailResponse(data),
     err => {
       this.docInfoSaveBtnLbl="Save";
       show_okshan_alert3("Something went wrong !");
       console.log('Something went wrong ', err);       
    })       
  }
  }

  

  /** saveInspectionDocDetailResponse method used to handle response */
  saveInspectionDocDetailResponse(response)
  {
    console.log('saveInspectionDocDetailResponse '+ response.status);
    if(response.status==="success")  
     {
       this.docInfoSaveBtnLbl="Save";
       show_okshan_alert3("Documents detail is saved");
       slide_up(".inspection-heading");
     }
     else
     {
     this.docInfoSaveBtnLbl="Save";  
     show_okshan_alert3(response.reason);     
     } 
  }

  //engineSoundVideoChange(event) {
  
  //  if (event.target.files.length > 0) {
  //    const file = event.target.files[0];
  //       this.engineSoundVideoFile= file;      
  //  }
  //  else{
  //     this.engineSoundVideoFile="";
  //  }
  //}  

  ratingExteriorTyresChange(rate)
  {
  this.ratingExteriorTyres=rate;  
  this.exteriorTyres=rate; 
  }

  ratingEngineTransmissionChange(rate)
  {
  this.ratingEngineTransmission=rate;  
  this.engineTransmission=rate; 
  }

  ratingAirConditionChange(rate)
  {
  this.ratingAirCondition=rate;
  this.airConditioning=rate;  
  }

  ratingElectricalsInteriorsChange(rate)
  {
  this.ratingElectricalsInteriors=rate; 
  this.electricalsInteriors=rate; 
  }

  ratingSteeringSuspensionBrakesChange(rate)
  {
  this.ratingSteeringSuspensionBrakes=rate;
  this.steeringSuspensionBrakes=rate; 
  }

  /** saveRatingDetail function used to save rating detail */
  saveRatingDetail()
  {
    this.isRatingInfoSubmit=true;    
     this.ratingInfoSaveBtnLbl="Saving";
     let body = { profile_id: this.sessionsService.getSession('id'),car_id:this.carId,exterior_tyres:this.ratingExteriorTyres,
     engine_transmission:this.ratingEngineTransmission,air_conditioning:this.ratingAirCondition,
     electricals_interiors:this.ratingElectricalsInteriors,Steering_suspension_brakes:this.ratingSteeringSuspensionBrakes};
     
     
     let result =this.httpserviceService.saveRatingDetailRequest(body).
     pipe(retry(0)).
     subscribe((data)=>this.saveRatingDetailResponse(data), 
     err => {
       this.ratingInfoSaveBtnLbl="Save";
       show_okshan_alert3("Something went wrong !");
       console.log('Something went wrong ', err);       
    })    
  }

  

  /** saveRatingDetailResponse method used to handle response */
  saveRatingDetailResponse(response)
  {
    console.log('saveRatingDetailResponse '+ response.status);
    if(response.status==="success")  
     {
       this.ratingInfoSaveBtnLbl="Save";
       show_okshan_alert3("Rating detail is saved");
       slide_up(".inspection-heading");
     }
     else
     {
     this.ratingInfoSaveBtnLbl="Save";  
     show_okshan_alert3(response.reason);     
     } 
  }


  /** getInspectionDetail function used to get inspection detail */
  getInspectionDetail()
  {
     let body = { profile_id: this.sessionsService.getSession('id'),car_id:this.carId};
     
     
     let result =this.httpserviceService.getInspectionDetailRequest(body).
     pipe(retry(0)).
     subscribe((data)=>this.getInspectionDetailResponse(data), 
     err => {
       show_okshan_alert3("Something went wrong !");
       console.log('Something went wrong ', err);       
    })    
  }

  

  /** getInspectionDetailResponse method used to handle response */
  getInspectionDetailResponse(response)
  {
    console.log('getInspectionDetailResponse '+ response.status);
    if(response.status==="success")  
     {
      this.setInspectionDetail(response);
     }
     else
     {
     show_okshan_alert3(response.reason);     
     } 
  }

  /** setInspectionDetail method used to set detail  */
  setInspectionDetail(response)
  {  
    if(response.basic_list)
    {
      if(response.basic_list[0].inspection_bit==0 || response.basic_list[0].inspection_bit==2)
      {
      this.inspectionEditStatus=true;
      } 
      this.brandNameBasic=response.basic_list[0].car_brand_name;
      this.modelNameBasic=response.basic_list[0].car_model_name;
      this.uidNameBasic=response.basic_list[0].uid;
      this.rtoNameBasic=response.basic_list[0].rto;
      this.firstNameBasic=response.basic_list[0].first_name;
      this.lastNameBasic=response.basic_list[0].last_name;
      this.AddressBasic=response.basic_list[0].address;
      this.cityBasic=this.getCityFromId(response.basic_list[0].city_id);
      this.stateBasic=this.getStateFromId(response.basic_list[0].state_id);
      this.postalBasic=response.basic_list[0].pin_code;
      this.emailBasic=response.basic_list[0].email_id;
      this.phoneBasic=response.basic_list[0].mobile_no;
      this.pic1Basic=response.basic_list[0].pic_1;
      this.pic2Basic=response.basic_list[0].pic_2;
      this.pic3Basic=response.basic_list[0].pic_3;
      this.pic4Basic=response.basic_list[0].pic_4;
      this.pic5Basic=response.basic_list[0].pic_5;
      this.pic6Basic=response.basic_list[0].pic_6;
      this.pic7Basic=response.basic_list[0].pic_7;
      this.rCExpiryBasic=response.basic_list[0].registration_expiry_date;
      this.variantBasic=this.getVariantFromId(response.basic_list[0].car_variants);
      this.fmvBasic=response.basic_list[0].fare_market_value;
      this.registrationNo=response.basic_list[0].registration_no;
      this.manufacturingYear=response.basic_list[0].registration_date;
      this.basicInfoFormGroup.controls['basicInfoRCExpiry'].setValue(response.basic_list[0].registration_expiry_date);
      this.basicInfoFormGroup.controls['basicInfoMileage'].setValue(response.basic_list[0].mileage);
      this.basicInfoFormGroup.controls['basicInfoVin'].setValue(response.basic_list[0].vin);
	  if(response.basic_list[0].pic_1 != ""){
		  this.p1 = 1;
	  }else{
		  this.p1 = 0;
	  }
	  if(response.basic_list[0].pic_2 != ""){
		  this.p2 = 1;
	  }else{
		  this.p2 = 0;
	  }
	  if(response.basic_list[0].pic_3 != ""){
		  this.p3 = 1;
	  }else{
		  this.p3 = 0;
	  }
	  if(response.basic_list[0].pic_4 != ""){
		  this.p4 = 1;
	  }else{
		  this.p4 = 0;
	  }
	  if(response.basic_list[0].pic_5 != ""){
		  this.p5 = 1;
	  }else{
		  this.p5 = 0;
	  }
	  if(response.basic_list[0].pic_6 != ""){
		  this.p6 = 1;
	  }else{
		  this.p6 = 0;
	  }
	  if(response.basic_list[0].pic_7 != ""){
		  this.p7 = 1;
	  }else{
		  this.p7 = 0;
	  }
	  this.tp = this.p1 + this.p2 + this.p3 + this.p4 + this.p5 + this.p6 + this.p7;
      if(response.basic_list[0].Keys_Keyless!="")
      {
      if(response.basic_list[0].Keys_Keyless==null)
      {
       response.basic_list[0].Keys_Keyless="";
      }
      response.basic_list[0].Keys_Keyless=response.basic_list[0].Keys_Keyless.split(",");
      }
      else
      {
      response.basic_list[0].Keys_Keyless=[];
      }
      this.basicInfoFormGroup.controls['basicInfoKeys'].setValue(response.basic_list[0].Keys_Keyless);
      if(response.basic_list[0].car_fuel_type_id!="")
      {
      if(response.basic_list[0].car_fuel_type_id==null)
      {
       response.basic_list[0].car_fuel_type_id="";
      }
      response.basic_list[0].car_fuel_type_id=response.basic_list[0].car_fuel_type_id.split(",");
      for(let m=0;m<response.basic_list[0].car_fuel_type_id.length;m++)
      {
         response.basic_list[0].car_fuel_type_id[m]=parseInt(response.basic_list[0].car_fuel_type_id[m]);
      }
      }
      else
      {
      response.basic_list[0].car_fuel_type_id=[];
      }
      this.basicInfoFormGroup.controls['basicInfoFuelType'].setValue(response.basic_list[0].car_fuel_type_id);
      this.basicInfoFormGroup.controls['basicInfoDocCharges'].setValue(response.basic_list[0].document_charges);
      this.basicInfoFormGroup.controls['basicInfoSeating'].setValue(response.basic_list[0].seating);
      this.basicInfoFormGroup.controls['basicInfoKMDriven'].setValue(response.basic_list[0].KM_driven);
      this.basicInfoFormGroup.controls['basicInfoEngineDisplacement'].setValue(response.basic_list[0].engine_displacement);
      this.basicInfoFormGroup.controls['basicInfoMaxTorque'].setValue(response.basic_list[0].max_torque);
      this.basicInfoFormGroup.controls['basicInfoBootSpace'].setValue(response.basic_list[0].boot_space);
      this.basicInfoFormGroup.controls['basicInfoMaxPower'].setValue(response.basic_list[0].max_power);
      this.basicInfoFormGroup.controls['basicInfoFuelTankCapacity'].setValue(response.basic_list[0].fuel_tank_capacity);
      if(response.basic_list[0].body_type!="")
      {
      if(response.basic_list[0].body_type==null)
      {
       response.basic_list[0].body_type="";
      }
      response.basic_list[0].body_type=response.basic_list[0].body_type.split(",");
      for(let m=0;m<response.basic_list[0].body_type.length;m++)
      {
         response.basic_list[0].body_type[m]=parseInt(response.basic_list[0].body_type[m]);
      }
      }
      else
      {
      response.basic_list[0].body_type=[];
      }
      this.basicInfoFormGroup.controls['basicInfoBodyType'].setValue(response.basic_list[0].body_type);
      if(response.basic_list[0].transmissiontype!="")
      {
      if(response.basic_list[0].transmissiontype==null)
      {
       response.basic_list[0].transmissiontype="";
      }
      response.basic_list[0].transmissiontype=response.basic_list[0].transmissiontype.split(",");
      }
      else
      {
      response.basic_list[0].transmissiontype=[];
      }
      this.basicInfoFormGroup.controls['basicInfoTransmissionType'].setValue(response.basic_list[0].transmissiontype); 
    }
    if(response.car_exterior_front)
    {
       let details=response.car_exterior_front[0];       
       for(let i=0;i<this.exteriorFrontXML.length;i++)
        {
          if(details["detail_"+(i+1)] && i!=24 && i!=25) 
          {
            let detailsArray=details["detail_"+(i+1)].split("@#^");
            if(detailsArray[0])
            {
            this.exteriorFrontDynamicFormGroup.controls["select_"+this.exteriorFrontXML[i].id].setValue(detailsArray[0].split(","))
            }
            if(detailsArray[1])
            {
            this.exteriorFrontDynamicFormGroup.controls["text_"+this.exteriorFrontXML[i].id].setValue(detailsArray[1])
            }
            if(detailsArray[2])
            {
            this.exteriorFrontXML[i].image=detailsArray[2];
            }  
         } else {
            let detailsArray=details["detail_"+(i+2)].split("@#^");
            if(detailsArray[0])
            {
            this.exteriorFrontDynamicFormGroup.controls["select_"+this.exteriorFrontXML[i].id].setValue(detailsArray[0].split(","))
            }
            if(detailsArray[1])
            {
            this.exteriorFrontDynamicFormGroup.controls["text_"+this.exteriorFrontXML[i].id].setValue(detailsArray[1])
            }
            if(detailsArray[2])
            {
            this.exteriorFrontXML[i].image=detailsArray[2];
            }
         }      
       }
    }
    if(response.car_exterior_other)
    {
       let details=response.car_exterior_other[0];       
        for(let i=0;i<this.exteriorOtherXML.length;i++)
        {
          if(details["detail_"+(i+1)] && i!=20 && i!=21 && i!=22) 
          {
            let detailsArray=details["detail_"+(i+1)].split("@#^");
            if(detailsArray[0])
            {
            this.exteriorOtherDynamicFormGroup.controls["select_"+this.exteriorOtherXML[i].id].setValue(detailsArray[0].split(","))
            }
            if(detailsArray[1])
            {
            this.exteriorOtherDynamicFormGroup.controls["text_"+this.exteriorOtherXML[i].id].setValue(detailsArray[1])
            }
            if(detailsArray[2])
            {
            this.exteriorOtherXML[i].image=detailsArray[2];
            }  
          } else {
            let detailsArray=details["detail_"+(i+2)].split("@#^");
            if(detailsArray[0])
            {
            this.exteriorOtherDynamicFormGroup.controls["select_"+this.exteriorOtherXML[i].id].setValue(detailsArray[0].split(","))
            }
            if(detailsArray[1])
            {
            this.exteriorOtherDynamicFormGroup.controls["text_"+this.exteriorOtherXML[i].id].setValue(detailsArray[1])
            }
            if(detailsArray[2])
            {
            this.exteriorOtherXML[i].image=detailsArray[2];
            } 
          }      
       }
    }
    if(response.car_tyres)
    {
       let details=response.car_tyres[0];       
      for(let i=0;i<this.tyresXML.length;i++)
        {
        let detailsArray=details["detail_"+(i+1)].split("@#^");
        if(detailsArray[0])
        {
        this.tyresDynamicFormGroup.controls["select_"+this.tyresXML[i].id].setValue(detailsArray[0].split(","))
        }
        if(detailsArray[1])
        {
        this.tyresDynamicFormGroup.controls["text_"+this.tyresXML[i].id].setValue(detailsArray[1])
        }
        if(detailsArray[2])
        {
        this.tyresXML[i].image=detailsArray[2];
        }        
       }
    }
    if(response.car_engine_detail)
    {
       let details=response.car_engine_detail[0];       
      for(let i=0;i<this.engineXML.length;i++)
        {
        let detailsArray=details["detail_"+(i+1)].split("@#^");
        if(detailsArray[0])
        {
        this.engineDynamicFormGroup.controls["select_"+this.engineXML[i].id].setValue(detailsArray[0].split(","))
        }
        if(detailsArray[1])
        {
        this.engineDynamicFormGroup.controls["text_"+this.engineXML[i].id].setValue(detailsArray[1])
        }
        if(detailsArray[2])
        {
        this.engineXML[i].image=detailsArray[2];
        }        
       }
    }
    if(response.car_interior_detail)
    {
       let details=response.car_interior_detail[0];       
      for(let i=0;i<this.interiorXML.length;i++)
        {
        let detailsArray=details["detail_"+(i+1)].split("@#^");
        if(detailsArray[0])
        {
        this.interiorDynamicFormGroup.controls["select_"+this.interiorXML[i].id].setValue(detailsArray[0].split(","))
        }
        if(detailsArray[1])
        {
        this.interiorDynamicFormGroup.controls["text_"+this.interiorXML[i].id].setValue(detailsArray[1])
        }
        if(detailsArray[2])
        {
        this.interiorXML[i].image=detailsArray[2];
        }        
       }
    } 
    if(response.car_air_condition)
    {
       let details=response.car_air_condition[0];       
      for(let i=0;i<this.aCXML.length;i++)
        {
        let detailsArray=details["detail_"+(i+1)].split("@#^");
        if(detailsArray[0])
        {
        this.aCDynamicFormGroup.controls["select_"+this.aCXML[i].id].setValue(detailsArray[0].split(","))
        }
        if(detailsArray[1])
        {
        this.aCDynamicFormGroup.controls["text_"+this.aCXML[i].id].setValue(detailsArray[1])
        }
        if(detailsArray[2])
        {
        this.aCXML[i].image=detailsArray[2];
        }        
       }
    }
    if(response.car_brakes)
    {
       let details=response.car_brakes[0];       
      for(let i=0;i<this.sSBXML.length;i++)
        {
        let detailsArray=details["detail_"+(i+1)].split("@#^");
        if(detailsArray[0])
        {
        this.sSBDynamicFormGroup.controls["select_"+this.sSBXML[i].id].setValue(detailsArray[0].split(","))
        }
        if(detailsArray[1])
        {
        this.sSBDynamicFormGroup.controls["text_"+this.sSBXML[i].id].setValue(detailsArray[1])
        }
        if(detailsArray[2])
        {
        this.sSBXML[i].image=detailsArray[2];
        }        
       }
    }
    if(response.document_list)
    {
       let details=response.document_list[0];       
        for(let i=0;i<this.documentXML.length;i++)
        {
        if(details["detail_"+(i+1)] && i!=20 && i!=21 && i!=22 && i!=23 && i!=24 && i!=25 ) 
        {
          let detailsArray=details["detail_"+(i+1)].split("@#^");
          if(detailsArray[0])
          {
          this.documentDynamicFormGroup.controls["select_"+this.documentXML[i].id].setValue(detailsArray[0].split(","))
          }
          if(detailsArray[1])
          {
          this.documentDynamicFormGroup.controls["text_"+this.documentXML[i].id].setValue(detailsArray[1])
          }
          if(detailsArray[2])
          {
          this.documentXML[i].image=detailsArray[2];
          } 
        } else {
          let detailsArray=details["detail_"+(i+2)].split("@#^");
          if(detailsArray[0])
          {
          this.documentDynamicFormGroup.controls["select_"+this.documentXML[i].id].setValue(detailsArray[0].split(","))
          }
          if(detailsArray[1])
          {
          this.documentDynamicFormGroup.controls["text_"+this.documentXML[i].id].setValue(detailsArray[1])
          }
          if(detailsArray[2])
          {
          this.documentXML[i].image=detailsArray[2];
          }
        }    
      }
    } 
    if(response.car_other_details)
    {
        //this.otherInspectionFormGroup.controls["otherExterior"].setValue(response.car_other_details[0].other_exterior_accessories_detail);
        //this.otherInspectionFormGroup.controls["otherTyres"].setValue(response.car_other_details[0].other_tyres_detail);
        //this.otherInspectionFormGroup.controls["otherEngine"].setValue(response.car_other_details[0].other_engine_detail);
        //this.otherInspectionFormGroup.controls["otherAc"].setValue(response.car_other_details[0].other_ac_detail);
        //this.otherInspectionFormGroup.controls["otherInterior"].setValue(response.car_other_details[0].other_interior_detail);
        //this.otherInspectionFormGroup.controls["otherSSB"].setValue(response.car_other_details[0].other_ssb_detail);
        //this.otherInspectionFormGroup.controls["otherBattery"].setValue(response.car_other_details[0].battery);
        //this.otherInspectionFormGroup.controls["otherBatteryYear"].setValue(response.car_other_details[0].battery_year);
        //this.otherInspectionFormGroup.controls["otherBatteryMake"].setValue(response.car_other_details[0].battery_make);
        this.otherEngineSoundVideo=response.car_other_details[0].engine_sound_video;
    } 
    if(response.car_highlights)
    {
        this.exteriorTyres=response.car_highlights[0].exterior_tyres;
        this.engineTransmission=response.car_highlights[0].engine_transmission;
        this.airConditioning=response.car_highlights[0].air_conditioning;
        this.electricalsInteriors=response.car_highlights[0].electricals_interiors;
        this.steeringSuspensionBrakes=response.car_highlights[0].Steering_suspension_brakes;
    } 
    if(response.highlights)
    {
        this.highlights=response.highlights;        
    }

    if(response.car_cooling_system)
    {
        let details=response.car_cooling_system[0];       
        for(let i=0;i<this.coolingSystemXML.length;i++)
        {
          let detailsArray=details["detail_"+(i+1)].split("@#^");
          if(detailsArray[0])
          {
            this.coolingSystemDynamicFormGroup.controls["select_"+this.coolingSystemXML[i].id].setValue(detailsArray[0].split(","))
          }
          if(detailsArray[1])
          {
            this.coolingSystemDynamicFormGroup.controls["text_"+this.coolingSystemXML[i].id].setValue(detailsArray[1])
          }
          if(detailsArray[2])
          {
            this.coolingSystemXML[i].image=detailsArray[2];
          }        
       }
    }

  }


  

  /** getStateFromId function used to get state from id  */
   getStateFromId(id)
   {
     if(this.sessionsService.getSession('all_state')==null)
     {
       return "";
     }
     let List=this.sessionsService.getSession('all_state');
     if(List.length==0)
     {
       return "";
     } 
     return List[id];
   } 

   /** getCityFromId function used to get city from id  */
   getCityFromId(id)
   {
     if(this.sessionsService.getSession('all_city')==null)
     {
       return "";
     }
     let List=this.sessionsService.getSession('all_city');
     if(List.length==0)
     {
       return "";
     } 
     return List[id];
   } 

   /** getVariantFromId function used to get variant from id  */
   getVariantFromId(id)
   {
     if(this.sessionsService.getSession('all_variant_list')==null)
     {
       return "";
     }
     let List=this.sessionsService.getSession('all_variant_list');
     if(List.length==0)
     {
       return "";
     } 
     return List[id];
   } 


  /** getCarBodyType function used to get car body type list */ 
  getCarBodyType()
  { 
    let result =this.httpserviceService.getCarBodyTypeRequest().
     pipe(retry(0)).
     subscribe((data)=>this.getCarBodyTypeResponse(data),
     err => {
      //  this.isRequestInprocess=false; 
        show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
  }  

  /** getCarBodyTypeResponse function used to handle response */
  getCarBodyTypeResponse(response)
  {    
    console.log('getBrandWithCountResponse '+ response.status);
    if(response.status==="success")  
     { 
       this.bodyTypetList=response.list;  
     }
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }

  /** loadExteriorFrontXML function used to load exterior front xml */
  loadExteriorFrontXML()
  {
    let result =this.httpserviceService.loadExteriorFrontXMLRequest().
     pipe(retry(0)).
     subscribe((data)=>this.loadExteriorFrontXMLResponse(data).then((data) => {  
           this.exteriorFrontXML = data;
           this.addInExteriorFrontFrom();  
          }),
     err => {
      //  this.isRequestInprocess=false; 
        show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** loadExteriorFrontXMLResponse function used to handle response */
  loadExteriorFrontXMLResponse(data)
  {    
    console.log('loadExteriorFrontXMLResponse '+ data);
    return new Promise(resolve => {  
      var k: string | number,  
        arr = [],  
        parser = new xml2js.Parser(  
          {  
            trim: true,  
            explicitArray: true  
          });  
      parser.parseString(data, function (err, result) {  
        var obj = result.exteriorFront;  
        for (k in obj.detail) { 
          var item = obj.detail[k]; 
          //for (m in item.select) {
          var select=item.select[0];
          var labelName=select.name[0];
          var optionList=[];
          for (var m in select.option) {
          var option=select.option[m]
          optionList.push({"id":option.bit[0],"name":option.label[0]});
          }
          //} 
          arr.push({  
            id: item.id[0],  
            name: labelName,  
            text: item.text[0],  
            pic: item.pic[0],
            image: "",
            optionList: optionList  
          });  
        }  
        resolve(arr);  
      });  
    });  
    
  }
   
   /** addInExteriorFrontFrom exterior form from xml */
   addInExteriorFrontFrom()
   {
   for(let i=0;i<this.exteriorFrontXML.length;i++)
    {
   if(this.exteriorFrontXML[i].optionList.length==0)
      {
      this.exteriorFrontDynamicFormGroup.addControl("select_"+this.exteriorFrontXML[i].id,new FormControl(''));
      }
      else
      {  
   this.exteriorFrontDynamicFormGroup.addControl("select_"+this.exteriorFrontXML[i].id,new FormControl('',[Validators.required]));
      }
   this.exteriorFrontDynamicFormGroup.addControl("text_"+this.exteriorFrontXML[i].id,new FormControl(''));
    }
    setTimeout(() => {
    this.exteriorFrontFromStatus=true;  
    }, 200);    
   }   

   /** exteriorFrontDynamicImageChange function used to keep image in list on change */
   exteriorFrontDynamicImageChange(id,event)
   {
      if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.exteriorFrontDynamicImages[id]=file;
         console.log('resize before:'+file.size);
        this.ng2ImgMaxService.resize([file], 800, 600).subscribe((result)=>{
        console.log('resize after result:'+result.size);
        this.exteriorFrontDynamicImages[id]= result; 
        },
        error=> {
          console.log('resize error:',error);
          this.exteriorFrontDynamicImages[id]=file;
        });      
      }
      else{
        this.exteriorFrontDynamicImages[id]="";
      }      
   }

   /** saveExteriorFrontDetail function used to save exterior front detail */
  saveExteriorFrontDetail(data)
  {
    this.isExteriorInfoSubmit=true;    
    if(this.exteriorFrontDynamicFormGroup.valid)
    { 
     this.exteriorInfoSaveBtnLbl="Saving";
     const formData = new FormData();
     formData.append("profile_id",this.sessionsService.getSession('id'));
     formData.append("car_id",this.carId);
     for(let i=0;i<this.exteriorFrontXML.length;i++)
    {
    let id=this.exteriorFrontXML[i].id;
    formData.append("detail_"+id,this.exteriorFrontDynamicFormGroup.controls["select_"+id].value+"@#^"+this.exteriorFrontDynamicFormGroup.controls["text_"+id].value);   
    if(this.exteriorFrontDynamicImages[id])
    {
    formData.append("detail_"+id+"_pic",this.exteriorFrontDynamicImages[id]);   
    }
    else
    { 
    formData.append("detail_"+id+"_pic","");   
    } 
    }    
     let result =this.httpserviceService.saveExteriorDetailRequest(formData).
     pipe(retry(0)).
     subscribe((data)=>this.saveExteriorDetailResponse(data),
     err => {
       this.exteriorInfoSaveBtnLbl="Save";
       show_okshan_alert3("Something went wrong !");
       console.log('Something went wrong ', err);       
    })       
  }
  }

  

  /** saveInspectionDocDetailResponse method used to handle response */
  saveExteriorDetailResponse(response)
  {
    console.log('saveExteriorDetailResponse '+ response.status);
    if(response.status==="success")  
     {
       this.exteriorInfoSaveBtnLbl="Save";
       show_okshan_alert3("Exterior Front detail is saved");
       slide_up(".inspection-heading");
     }
     else
     {
     this.exteriorInfoSaveBtnLbl="Save";  
     show_okshan_alert3(response.reason);     
     } 
  }

  /** loadExteriorOtherXML function used to load exterior other xml */
  loadExteriorOtherXML()
  {
    let result =this.httpserviceService.loadExteriorOtherXMLRequest().
     pipe(retry(0)).
     subscribe((data)=>this.loadExteriorOtherXMLResponse(data).then((data) => {  
           this.exteriorOtherXML = data;
           this.addInExteriorOtherFrom();  
          }),
     err => {
      //  this.isRequestInprocess=false; 
        show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** loadExteriorOtherXMLResponse function used to handle response */
  loadExteriorOtherXMLResponse(data)
  {    
    console.log('loadExteriorOtherXMLResponse '+ data);
    return new Promise(resolve => {  
      var k: string | number,  
        arr = [],  
        parser = new xml2js.Parser(  
          {  
            trim: true,  
            explicitArray: true  
          });  
      parser.parseString(data, function (err, result) {  
        var obj = result.exteriorOther;  
        for (k in obj.detail) { 
          var item = obj.detail[k]; 
          //for (m in item.select) {
          var select=item.select[0];
          var labelName=select.name[0];
          var optionList=[];
          for (var m in select.option) {
          var option=select.option[m]
          optionList.push({"id":option.bit[0],"name":option.label[0]});
          }
          //} 
          arr.push({  
            id: item.id[0],  
            name: labelName,  
            text: item.text[0],  
            pic: item.pic[0],
            image: "",
            optionList: optionList  
          });  
        }  
        resolve(arr);  
      });  
    });  
    
  }
   
   /** addInExteriorFrontFrom exterior form from xml */
   addInExteriorOtherFrom()
   {
   for(let i=0;i<this.exteriorOtherXML.length;i++)
    {
    if(this.exteriorOtherXML[i].optionList.length==0)
      {
      this.exteriorOtherDynamicFormGroup.addControl("select_"+this.exteriorOtherXML[i].id,new FormControl(''));
      }
      else
      {
   this.exteriorOtherDynamicFormGroup.addControl("select_"+this.exteriorOtherXML[i].id,new FormControl('',[Validators.required]));
      }
   this.exteriorOtherDynamicFormGroup.addControl("text_"+this.exteriorOtherXML[i].id,new FormControl(''));
    }    
    setTimeout(() => {
    this.exteriorOtherFromStatus=true;  
    }, 200);
   }   

  /** exteriorOtherDynamicImageChange function used to keep image in list on change */
   exteriorOtherDynamicImageChange(id,event)
   {
      if (event.target.files.length > 0) {
      const file = event.target.files[0];
         this.exteriorOtherDynamicImages[id]= file; 
         console.log('resize before:'+file.size);
        this.ng2ImgMaxService.resize([file], 800, 600).subscribe((result)=>{
        console.log('resize after result:'+result.size);
        this.exteriorOtherDynamicImages[id]= result; 
        },
        error=> {
          console.log('resize error:',error);
          this.exteriorOtherDynamicImages[id]=file;
        });     
      }
      else{
        this.exteriorOtherDynamicImages[id]="";
      }      
   }

   /** saveExteriorOtherDetail function used to save exterior other detail */
  saveExteriorOtherDetail(data)
  {
    this.isExteriorOtherInfoSubmit=true;    
    if(this.exteriorOtherDynamicFormGroup.valid)
    { 
     this.exteriorOtherInfoSaveBtnLbl="Saving";
     const formData = new FormData();
     formData.append("profile_id",this.sessionsService.getSession('id'));
     formData.append("car_id",this.carId);
     for(let i=0;i<this.exteriorOtherXML.length;i++)
    {
    let id=this.exteriorOtherXML[i].id;
    formData.append("detail_"+id,this.exteriorOtherDynamicFormGroup.controls["select_"+id].value+"@#^"+this.exteriorOtherDynamicFormGroup.controls["text_"+id].value);   
    if(this.exteriorOtherDynamicImages[id])
    {
    formData.append("detail_"+id+"_pic",this.exteriorOtherDynamicImages[id]);   
    }
    else
    { 
    formData.append("detail_"+id+"_pic","");   
    } 
    } 
     
     let result =this.httpserviceService.saveExteriorOtherDetailRequest(formData).
     pipe(retry(0)).
     subscribe((data)=>this.saveExteriorOtherDetailResponse(data),
     err => {
       this.exteriorOtherInfoSaveBtnLbl="Save";
       show_okshan_alert3("Something went wrong !");
       console.log('Something went wrong ', err);       
    })       
  }
  }  

  /** saveExteriorOtherDetailResponse method used to handle response */
  saveExteriorOtherDetailResponse(response)
  { 
    console.log('saveExteriorOtherDetailResponse '+ response.status);
    if(response.status==="success")  
     {
       this.exteriorOtherInfoSaveBtnLbl="Save";
       show_okshan_alert3("Exterior Other detail is saved");
       slide_up(".inspection-heading");
     }
     else
     {
     this.exteriorOtherInfoSaveBtnLbl="Save";  
     show_okshan_alert3(response.reason);     
     } 
  }

  /** loadTyresXML function used to load tyres xml */
  loadTyresXML()
  {
    let result =this.httpserviceService.loadTyresXMLRequest().
     pipe(retry(0)).
     subscribe((data)=>this.loadTyresXMLResponse(data).then((data) => {  
           this.tyresXML = data;
           this.addInTyresFrom();  
          }),
     err => {
      //  this.isRequestInprocess=false; 
        show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** loadTyresXMLResponse function used to handle response */
  loadTyresXMLResponse(data)
  {    
    console.log('loadTyresXMLResponse '+ data);
    return new Promise(resolve => {  
      var k: string | number,  
        arr = [],  
        parser = new xml2js.Parser(  
          {  
            trim: true,  
            explicitArray: true  
          });  
      parser.parseString(data, function (err, result) {  
        var obj = result.tyres;  
        for (k in obj.detail) { 
          var item = obj.detail[k]; 
          //for (m in item.select) {
          var select=item.select[0];
          var labelName=select.name[0];
          var optionList=[];
          for (var m in select.option) {
          var option=select.option[m]
          optionList.push({"id":option.bit[0],"name":option.label[0]});
          }
          //} 
          arr.push({  
            id: item.id[0],  
            name: labelName,  
            text: item.text[0],  
            pic: item.pic[0],
            image: "",
            optionList: optionList  
          });  
        }  
        resolve(arr);  
      });  
    });  
    
  }
   
   /** addInTyresFrom exterior form from xml */
   addInTyresFrom()
   {
   for(let i=0;i<this.tyresXML.length;i++)
    {
    if(this.tyresXML[i].optionList.length==0)
      {
    this.tyresDynamicFormGroup.addControl("select_"+this.tyresXML[i].id,new FormControl(''));  
      }
      else
      {
   this.tyresDynamicFormGroup.addControl("select_"+this.tyresXML[i].id,new FormControl(''),[Validators.required]);
       }
   this.tyresDynamicFormGroup.addControl("text_"+this.tyresXML[i].id,new FormControl(''));
    }    
    setTimeout(() => {
    this.tyresFromStatus=true;  
    }, 200);
   }   

   /** tyresDynamicImageChange function used to keep image in list on change */ 
   tyresDynamicImageChange(id,event)
   {
      if (event.target.files.length > 0) {
      const file = event.target.files[0];
         this.tyresDynamicImages[id]= file;
         console.log('resize before:'+file.size);
        this.ng2ImgMaxService.resize([file], 800, 600).subscribe((result)=>{
        console.log('resize after result:'+result.size);
        this.tyresDynamicImages[id]= result; 
        },
        error=> {
          console.log('resize error:',error);
          this.tyresDynamicImages[id]=file;
        });       
      }
      else{
        this.tyresDynamicImages[id]="";
      }      
   }

   /** saveTyresDetail function used to save tyres detail */
  saveTyresDetail(data)
  {  
    this.isTyresInfoSubmit=true;    
    //if(this.tyresDynamicFormGroup.valid)
    { 
     this.tyresInfoSaveBtnLbl="Saving";
     const formData = new FormData();
     formData.append("profile_id",this.sessionsService.getSession('id'));
     formData.append("car_id",this.carId);
     for(let i=0;i<this.tyresXML.length;i++)
    {
    let id=this.tyresXML[i].id;
    formData.append("detail_"+id,this.tyresDynamicFormGroup.controls["select_"+id].value+"@#^"+this.tyresDynamicFormGroup.controls["text_"+id].value);   
    if(this.tyresDynamicImages[id])
    {
    formData.append("detail_"+id+"_pic",this.tyresDynamicImages[id]);   
    }
    else
    { 
    formData.append("detail_"+id+"_pic","");   
    } 
    } 
     
     let result =this.httpserviceService.saveExteriorTyresDetailRequest(formData).
     pipe(retry(0)).
     subscribe((data)=>this.saveTyresDetailResponse(data),
     err => {
       this.tyresInfoSaveBtnLbl="Save";
       show_okshan_alert3("Something went wrong !");
       console.log('Something went wrong ', err);       
    })       
  }
  }

  

  /** saveExteriorTyresDetailResponse method used to handle response */
  saveTyresDetailResponse(response)
  { 
    console.log('saveExteriorTyresDetailResponse '+ response.status);
    if(response.status==="success")  
     {
       this.tyresInfoSaveBtnLbl="Save";
       show_okshan_alert3("Tyres detail is saved");
       slide_up(".inspection-heading");
     }
     else
     {
     this.tyresInfoSaveBtnLbl="Save";  
     show_okshan_alert3(response.reason);     
     } 
  }

  /** loadEngineXML function used to load engine xml */
  loadEngineXML()
  {
    let result =this.httpserviceService.loadEngineXMLRequest().
     pipe(retry(0)).
     subscribe((data)=>this.loadEngineXMLResponse(data).then((data) => {  
           this.engineXML = data;
           this.addInEngineFrom();  
          }),
     err => {
      //  this.isRequestInprocess=false; 
        show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** loadEngineXMLResponse function used to handle response */
  loadEngineXMLResponse(data)
  {    
    console.log('loadEngineXMLResponse '+ data);
    return new Promise(resolve => {  
      var k: string | number,  
        arr = [],  
        parser = new xml2js.Parser(  
          {  
            trim: true,  
            explicitArray: true  
          });  
      parser.parseString(data, function (err, result) {  
        var obj = result.engine;  
        for (k in obj.detail) { 
          var item = obj.detail[k]; 
          //for (m in item.select) {
          var select=item.select[0];
          var labelName=select.name[0];
          var optionList=[];
          for (var m in select.option) {
          var option=select.option[m]
          optionList.push({"id":option.bit[0],"name":option.label[0]});
          }
          //} 
          arr.push({  
            id: item.id[0],  
            name: labelName,  
            text: item.text[0],  
            pic: item.pic[0],
            image: "",
            optionList: optionList  
          });  
        }  
        resolve(arr);  
      });  
    });  
    
  }
   
   /** addInEngineFrom exterior form from xml */
   addInEngineFrom()
   {
   for(let i=0;i<this.engineXML.length;i++)
    {
   
if(this.engineXML[i].optionList.length==0)
      {
      this.engineDynamicFormGroup.addControl("select_"+this.engineXML[i].id,new FormControl(''));
      }
      else
      { 
      this.engineDynamicFormGroup.addControl("select_"+this.engineXML[i].id,new FormControl('',[Validators.required]));
      }
   this.engineDynamicFormGroup.addControl("text_"+this.engineXML[i].id,new FormControl(''));
    }
    setTimeout(() => {
    this.engineFromStatus=true;  
    }, 200);    
   }   

   /** engineDynamicImageChange function used to keep image in list on change */
   engineDynamicImageChange(id,event)
   {
      if (event.target.files.length > 0) {
      const file = event.target.files[0];
         this.engineDynamicImages[id]= file; 
         console.log('resize before:'+file.size);
        this.ng2ImgMaxService.resize([file], 800, 600).subscribe((result)=>{
        console.log('resize after result:'+result.size);
        this.engineDynamicImages[id]= result; 
        },
        error=> {
          console.log('resize error:',error);
          this.engineDynamicImages[id]=file;
        });     
      }
      else{
        this.engineDynamicImages[id]="";
      }      
   }

/** saveEngineDetail function used to save engine detail */
  saveEngineDetail(data)
  {
    this.isEngineInfoSubmit=true;       
    if(this.engineDynamicFormGroup.valid)
    { 
     this.engineInfoSaveBtnLbl="Saving";
     const formData = new FormData();
     formData.append("profile_id",this.sessionsService.getSession('id'));
     formData.append("car_id",this.carId);
     for(let i=0;i<this.engineXML.length;i++)
    {
    let id=this.engineXML[i].id;
    formData.append("detail_"+id,this.engineDynamicFormGroup.controls["select_"+id].value+"@#^"+this.engineDynamicFormGroup.controls["text_"+id].value);   
    if(this.engineDynamicImages[id])
    {
    formData.append("detail_"+id+"_pic",this.engineDynamicImages[id]);   
    }
    else
    { 
    formData.append("detail_"+id+"_pic","");   
    } 
    }
     
     let result =this.httpserviceService.saveEngineDetailRequest(formData).
     pipe(retry(0)).
     subscribe((data)=>this.saveEngineDetailResponse(data),
     err => {
       this.engineInfoSaveBtnLbl="Save";
       show_okshan_alert3("Something went wrong !");
       console.log('Something went wrong ', err);       
    })       
  }
  }

  

  /** saveEngineDetailResponse method used to handle response */
  saveEngineDetailResponse(response)
  {
    console.log('saveEngineDetailResponse '+ response.status);
    if(response.status==="success")  
     {
       this.engineInfoSaveBtnLbl="Save";
       show_okshan_alert3("Engine and transmission detail is saved");
       slide_up(".inspection-heading");
     }
     else
     {
     this.engineInfoSaveBtnLbl="Save";  
     show_okshan_alert3(response.reason);     
     } 
  }

  /** loadInteriorXML function used to load Interior xml */
  loadInteriorXML()
  {
    let result =this.httpserviceService.loadInteriorXMLRequest().
     pipe(retry(0)).
     subscribe((data)=>this.loadInteriorXMLResponse(data).then((data) => {  
           this.interiorXML = data;
           this.addInInteriorFrom();  
          }),
     err => {
      //  this.isRequestInprocess=false; 
        show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** loadInteriorXMLResponse function used to handle response */
  loadInteriorXMLResponse(data)
  {    
    console.log('loadInteriorXMLResponse '+ data);
    return new Promise(resolve => {  
      var k: string | number,  
        arr = [],  
        parser = new xml2js.Parser(  
          {  
            trim: true,  
            explicitArray: true  
          });  
      parser.parseString(data, function (err, result) {  
        var obj = result.interior;  
        for (k in obj.detail) { 
          var item = obj.detail[k]; 
          //for (m in item.select) {
          var select=item.select[0];
          var labelName=select.name[0];
          var optionList=[];
          for (var m in select.option) {
          var option=select.option[m]
          optionList.push({"id":option.bit[0],"name":option.label[0]});
          }
          //} 
          arr.push({  
            id: item.id[0],  
            name: labelName,  
            text: item.text[0],  
            pic: item.pic[0],
            image: "",
            optionList: optionList  
          });  
        }  
        resolve(arr);  
      });  
    });  
    
  }
   
   /** addInInteriorFrom exterior form from xml */
   addInInteriorFrom()
   {
   for(let i=0;i<this.interiorXML.length;i++)
    {
    if(this.interiorXML[i].optionList.length==0)
      {
    this.interiorDynamicFormGroup.addControl("select_"+this.interiorXML[i].id,new FormControl(''));  
      }
      else
      {
   this.interiorDynamicFormGroup.addControl("select_"+this.interiorXML[i].id,new FormControl('',[Validators.required]));
      }
   this.interiorDynamicFormGroup.addControl("text_"+this.interiorXML[i].id,new FormControl(''));
    }
    setTimeout(() => {
    this.interiorFromStatus=true;  
    }, 200);    
   }

   /** interiorDynamicImageChange function used to keep image in list on change */
   interiorDynamicImageChange(id,event)
   {
      if (event.target.files.length > 0) 
      {
        const file = event.target.files[0];
        this.interiorDynamicImages[id]=file;
        console.log('resize before:'+file.size);
          this.ng2ImgMaxService.resize([file], 800, 600).subscribe((result)=>{
          console.log('resize after result:'+result.size);
          this.interiorDynamicImages[id]= result; 
          },
          error=> {
            console.log('resize error:',error);
            this.interiorDynamicImages[id]=file;
          });
              
      }
      else
      {
        this.interiorDynamicImages[id]="";
      }      
   }

   /** saveInteriorDetail function used to save interior detail */
  saveInteriorDetail(data)
  {
    this.isInteriorInfoSubmit=true;    
    if(this.interiorDynamicFormGroup.valid)
    { 
     this.interiorInfoSaveBtnLbl="Saving";
     const formData = new FormData();
     formData.append("profile_id",this.sessionsService.getSession('id'));
     formData.append("car_id",this.carId);
     for(let i=0;i<this.interiorXML.length;i++)
    {
    let id=this.interiorXML[i].id;
    formData.append("detail_"+id,this.interiorDynamicFormGroup.controls["select_"+id].value+"@#^"+this.interiorDynamicFormGroup.controls["text_"+id].value);   
    if(this.interiorDynamicImages[id])
    {
    formData.append("detail_"+id+"_pic",this.interiorDynamicImages[id]);   
    }
    else
    { 
    formData.append("detail_"+id+"_pic","");   
    } 
    }
     
     
     let result =this.httpserviceService.saveInteriorDetailRequest(formData).
     pipe(retry(0)).
     subscribe((data)=>this.saveInteriorDetailResponse(data), 
     err => {
       this.interiorInfoSaveBtnLbl="Save";
       show_okshan_alert3("Something went wrong !");
       console.log('Something went wrong ', err);       
    })       
  }
  }

  

  /** saveInteriorDetailResponse method used to handle response */
  saveInteriorDetailResponse(response)
  {
    console.log('saveInteriorDetailResponse '+ response.status);
    if(response.status==="success")  
     {
       this.interiorInfoSaveBtnLbl="Save";
       show_okshan_alert3("Interior detail is saved");
       slide_up(".inspection-heading");
     }
     else
     {
     this.interiorInfoSaveBtnLbl="Save";  
     show_okshan_alert3(response.reason);     
     } 
  }

  /** loadACXML function used to load AC xml */
  loadACXML()
  {
    let result =this.httpserviceService.loadACXMLRequest().
     pipe(retry(0)).
     subscribe((data)=>this.loadACXMLResponse(data).then((data) => {  
           this.aCXML = data;
           this.addInACFrom();  
          }),
     err => {
      //  this.isRequestInprocess=false; 
        show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** loadACXMLResponse function used to handle response */
  loadACXMLResponse(data)
  {    
    console.log('loadACXMLResponse '+ data);
    return new Promise(resolve => {  
      var k: string | number,  
        arr = [],  
        parser = new xml2js.Parser(  
          {  
            trim: true,  
            explicitArray: true  
          });  
      parser.parseString(data, function (err, result) {  
        var obj = result.ac;  
        for (k in obj.detail) { 
          var item = obj.detail[k]; 
          //for (m in item.select) {
          var select=item.select[0];
          var labelName=select.name[0];
          var optionList=[];
          for (var m in select.option) {
          var option=select.option[m]
          optionList.push({"id":option.bit[0],"name":option.label[0]});
          }
          //} 
          arr.push({  
            id: item.id[0],  
            name: labelName,  
            text: item.text[0],  
            pic: item.pic[0],
            image: "",
            optionList: optionList  
          });  
        }  
        resolve(arr);  
      });  
    });  
    
  }
   
   /** addInACFrom exterior form from xml */
   addInACFrom()
   {
   for(let i=0;i<this.aCXML.length;i++)
    {
    if(this.aCXML[i].optionList.length==0)
      {
    this.aCDynamicFormGroup.addControl("select_"+this.aCXML[i].id,new FormControl(''));  
      }
      else
      {
   this.aCDynamicFormGroup.addControl("select_"+this.aCXML[i].id,new FormControl('',[Validators.required]));
      }
   this.aCDynamicFormGroup.addControl("text_"+this.aCXML[i].id,new FormControl(''));
    }
    setTimeout(() => {
    this.aCFromStatus=true;  
    }, 200);    
   }

   /** aCDynamicImageChange function used to keep image in list on change */
   aCDynamicImageChange(id,event)
   {
      if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.aCDynamicImages[id]=file;
      console.log('resize before:'+file.size);
        this.ng2ImgMaxService.resize([file], 800, 600).subscribe((result)=>{
        console.log('resize after result:'+result.size);
        this.aCDynamicImages[id]= result; 
        },
        error=> {
          console.log('resize error:',error);
          this.aCDynamicImages[id]=file;
        });
              
      }
      else{
        this.aCDynamicImages[id]="";
      }      
   } 

   /** saveAcDetail function used to save ac detail */
  saveAcDetail(data)
  {    
    this.isACInfoSubmit=true;
    if(this.aCDynamicFormGroup.valid)
    { 
     this.aCInfoSaveBtnLbl="Saving";
     const formData = new FormData();
     formData.append("profile_id",this.sessionsService.getSession('id'));
     formData.append("car_id",this.carId);
     for(let i=0;i<this.aCXML.length;i++)
    {
    let id=this.aCXML[i].id;
    formData.append("detail_"+id,this.aCDynamicFormGroup.controls["select_"+id].value+"@#^"+this.aCDynamicFormGroup.controls["text_"+id].value);   
    if(this.aCDynamicImages[id])
    {
    formData.append("detail_"+id+"_pic",this.aCDynamicImages[id]);   
    }
    else
    { 
    formData.append("detail_"+id+"_pic","");   
    }
    }
     let result =this.httpserviceService.saveAcDetailRequest(formData).
     pipe(retry(0)).
     subscribe((data)=>this.saveAcDetailResponse(data),
     err => {
       this.aCInfoSaveBtnLbl="Save";
       show_okshan_alert3("Something went wrong !");
       console.log('Something went wrong ', err);       
    })       
  }
  }

  

  /** saveAcDetailResponse method used to handle response */
  saveAcDetailResponse(response)
  {
    console.log('saveAcDetailResponse '+ response.status);
    if(response.status==="success")  
     {
       this.aCInfoSaveBtnLbl="Save";
       show_okshan_alert3("AC detail is saved");
       slide_up(".inspection-heading");
     }
     else
     {
     this.aCInfoSaveBtnLbl="Save";  
     show_okshan_alert3(response.reason);     
     } 
  } 

  /** loadSSBXML function used to load steering suspension and break xml */
  loadSSBXML()
  {
    let result =this.httpserviceService.loadSSBXMLRequest().
     pipe(retry(0)).
     subscribe((data)=>this.loadSSBXMLResponse(data).then((data) => {  
           this.sSBXML = data;
           this.addInSSBFrom();  
          }),
     err => {
      //  this.isRequestInprocess=false; 
        show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** loadSSBXMLResponse function used to handle response */
  loadSSBXMLResponse(data)
  {    
    console.log('loadSSBXMLResponse '+ data);
    return new Promise(resolve => {  
      var k: string | number,  
        arr = [],  
        parser = new xml2js.Parser(  
          {  
            trim: true,  
            explicitArray: true  
          });  
      parser.parseString(data, function (err, result) {  
        var obj = result.ssb;  
        for (k in obj.detail) { 
          var item = obj.detail[k]; 
          //for (m in item.select) {
          var select=item.select[0];
          var labelName=select.name[0];
          var optionList=[];
          for (var m in select.option) {
          var option=select.option[m]
          optionList.push({"id":option.bit[0],"name":option.label[0]});
          }
          //} 
          arr.push({  
            id: item.id[0],  
            name: labelName,  
            text: item.text[0],  
            pic: item.pic[0],
            image: "",
            optionList: optionList  
          });  
        }  
        resolve(arr);  
      });  
    });  
    
  }
   
   /** addInSSBFrom exterior form from xml */
   addInSSBFrom()
   {
   for(let i=0;i<this.sSBXML.length;i++)
    {
    if(this.sSBXML[i].optionList.length==0)
      {
      this.sSBDynamicFormGroup.addControl("select_"+this.sSBXML[i].id,new FormControl(''));
      }
      else
      {
   this.sSBDynamicFormGroup.addControl("select_"+this.sSBXML[i].id,new FormControl('',[Validators.required]));
     }
   this.sSBDynamicFormGroup.addControl("text_"+this.sSBXML[i].id,new FormControl(''));
    }
    setTimeout(() => {
    this.sSBFromStatus=true;  
    }, 200);    
   }

   /** sSBDynamicImageChange function used to keep image in list on change */
   sSBDynamicImageChange(id,event)
   {
      if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.sSBDynamicImages[id]=file;
      console.log('resize before:'+file.size);
        this.ng2ImgMaxService.resize([file], 800, 600).subscribe((result)=>{
        console.log('resize after result:'+result.size);
        this.sSBDynamicImages[id]= result; 
        },
        error=> {
          console.log('resize error:',error);
          this.sSBDynamicImages[id]=file;
        });
              
      }
      else{
        this.sSBDynamicImages[id]="";
      }      
   } 

   /** saveSsbDetail function used to save Steering suspension and brakes detail */
  saveSsbDetail(data)
  {
    this.isSSBInfoSubmit=true;    
    if(this.sSBDynamicFormGroup.valid)
    { 
     this.sSBInfoSaveBtnLbl="Saving";
     const formData = new FormData();
     formData.append("profile_id",this.sessionsService.getSession('id'));
     formData.append("car_id",this.carId);
     for(let i=0;i<this.sSBXML.length;i++)
    {
    let id=this.sSBXML[i].id;
    formData.append("detail_"+id,this.sSBDynamicFormGroup.controls["select_"+id].value+"@#^"+this.sSBDynamicFormGroup.controls["text_"+id].value);   
    if(this.sSBDynamicImages[id])
    {
    formData.append("detail_"+id+"_pic",this.sSBDynamicImages[id]);   
    }
    else
    { 
    formData.append("detail_"+id+"_pic","");   
    }
    }
     let result =this.httpserviceService.saveSsbDetailRequest(formData).
     pipe(retry(0)).
     subscribe((data)=>this.saveSsbDetailResponse(data), 
     err => {
       this.sSBInfoSaveBtnLbl="Save";
       show_okshan_alert3("Something went wrong !");
       console.log('Something went wrong ', err);       
    })       
  }
  }

  

  /** saveSsbDetailResponse method used to handle response */
  saveSsbDetailResponse(response)
  {
    console.log('saveSsbDetailResponse '+ response.status);
    if(response.status==="success")  
     {
       this.sSBInfoSaveBtnLbl="Save";
       show_okshan_alert3("Steering suspension and brakes detail is saved");
       slide_up(".inspection-heading");
     }
     else
     {
     this.sSBInfoSaveBtnLbl="Save";  
     show_okshan_alert3(response.reason);     
     } 
  }





  
  /** loadCoolingSystemXML function used to load steering suspension and break xml */
  loadCoolingSystemXML()
  {
    let result =this.httpserviceService.loadCoolingSystemXMLRequest().
     pipe(retry(0)).
     subscribe((data)=>this.loadCoolingSystemXMLResponse(data).then((data) => {  
           this.coolingSystemXML = data;
           this.addInCoolingSystemFrom();  
          }),
     err => {
        //  this.isRequestInprocess=false; 
        show_okshan_alert("Something went wrong !");
        console.log('Something went wrong ', err);       
    })
  }

  /** loadCoolingSystemXMLResponse function used to handle response */
  loadCoolingSystemXMLResponse(data)
  {    
    console.log('loadCoolingSystemXMLResponse '+ data);
    return new Promise(resolve => {  
      var k: string | number,  
        arr = [],  
        parser = new xml2js.Parser(  
          {  
            trim: true,  
            explicitArray: true  
          });  
        parser.parseString(data, function (err, result) {  
        var obj = result.coolingsystem;  
        for (k in obj.detail) { 
          var item = obj.detail[k]; 
          //for (m in item.select) {
          var select=item.select[0];
          var labelName=select.name[0];
          var optionList=[];
          for (var m in select.option) {
          var option=select.option[m]
          optionList.push({"id":option.bit[0],"name":option.label[0]});
          }
          //} 
          arr.push({  
            id: item.id[0],  
            name: labelName,  
            text: item.text[0],  
            pic: item.pic[0],
            image: "",
            optionList: optionList  
          });  
        }  
        resolve(arr);  
      });  
    });  
    
  }
   
   /** addIncoolingSystemFrom exterior form from xml */
   addInCoolingSystemFrom()
   {
     for(let i=0;i<this.coolingSystemXML.length;i++)
      {
      if(this.coolingSystemXML[i].optionList.length==0)
        {
          this.coolingSystemDynamicFormGroup.addControl("select_"+this.coolingSystemXML[i].id,new FormControl(''));
        }
        else
        {
          this.coolingSystemDynamicFormGroup.addControl("select_"+this.coolingSystemXML[i].id,new FormControl('',[Validators.required]));
       }
          this.coolingSystemDynamicFormGroup.addControl("text_"+this.coolingSystemXML[i].id,new FormControl(''));
      }
      setTimeout(() => {
      this.coolingSystemFromStatus=true;  
      }, 200);    
   }

   /** coolingSystemDynamicImageChange function used to keep image in list on change */
   coolingSystemDynamicImageChange(id,event)
   {
      if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.coolingSystemDynamicImages[id]=file;
      console.log('resize before:'+file.size);
        this.ng2ImgMaxService.resize([file], 800, 600).subscribe((result)=>{
        console.log('resize after result:'+result.size);
        this.coolingSystemDynamicImages[id]= result; 
        },
        error=> {
          console.log('resize error:',error);
          this.coolingSystemDynamicImages[id]=file;
        });
              
      }
      else{
        this.coolingSystemDynamicImages[id]="";
      }      
   } 

   /** saveCoolingSystemDetail function used to save Steering suspension and brakes detail */
  saveCoolingSystemDetail(data)
  {
    this.isCoolingSystemInfoSubmit=true;    
    if(this.coolingSystemDynamicFormGroup.valid)
    { 
     this.coolingSystemInfoSaveBtnLbl="Saving";
     const formData = new FormData();
     formData.append("profile_id",this.sessionsService.getSession('id'));
     formData.append("car_id",this.carId);
     for(let i=0;i<this.coolingSystemXML.length;i++)
    {
    let id=this.coolingSystemXML[i].id;
    formData.append("detail_"+id,this.coolingSystemDynamicFormGroup.controls["select_"+id].value+"@#^"+this.coolingSystemDynamicFormGroup.controls["text_"+id].value);   
    if(this.coolingSystemDynamicImages[id])
    {
    formData.append("detail_"+id+"_pic",this.coolingSystemDynamicImages[id]);   
    }
    else
    { 
    formData.append("detail_"+id+"_pic","");   
    }
    }
     let result =this.httpserviceService.saveCoolingSystembDetailRequest(formData).
     pipe(retry(0)).
     subscribe((data)=>this.saveCoolingSystemDetailResponse(data), 
     err => {
       this.coolingSystemInfoSaveBtnLbl="Save";
       show_okshan_alert3("Something went wrong !");
       console.log('Something went wrong ', err);       
    })       
  }
  }

  

  /** saveCoolingSystemDetailResponse method used to handle response */
  saveCoolingSystemDetailResponse(response)
  {
    console.log('saveSsbDetailResponse '+ response.status);
    if(response.status==="success")  
     {
       this.coolingSystemInfoSaveBtnLbl="Save";
       show_okshan_alert3("Steering suspension and brakes detail is saved");
       slide_up(".inspection-heading");
     }
     else
     {
      this.coolingSystemInfoSaveBtnLbl="Save";  
      show_okshan_alert3(response.reason);     
     } 
  }
















  /** saveOtherInspectionDetail function used to save other inspection detail */
  saveOtherInspectionDetail(data)
  {
    this.isOtherInspectionInfoSubmit=true;    
    //if(this.docInfoFormGroup.valid)
    { 
     this.otherInspectionInfoSaveBtnLbl="Saving";

     const formData = new FormData();
     formData.append("profile_id",this.sessionsService.getSession('id'));
     formData.append("car_id",this.carId);
     //formData.append("accessories_detail",data.otherExterior)
     //formData.append("other_tyres_detail",data.otherTyres)
     //formData.append("other_engine_detail",data.otherEngine)
     //formData.append("other_ac_detail",data.otherAc)
     //formData.append("other_interior_detail",data.otherInterior)
     //formData.append("other_ssb_detail",data.otherSSB)
     //formData.append("battery",data.otherBattery)
     //formData.append("battery_year",data.otherBatteryYear)
     //formData.append("battery_make",data.otherBatteryMake)
     formData.append("engine_sound_video",this.otherInspectionEngineSoundVideoFile)

     let result =this.httpserviceService.saveOtherInspectionDetailRequest(formData).
     pipe(retry(0)).
     subscribe((data)=>this.saveOtherInspectionDetailResponse(data),
     err => {
       this.otherInspectionInfoSaveBtnLbl="Save";
       show_okshan_alert3("Something went wrong !");
       console.log('Something went wrong ', err);       
    })       
  }
  }

  

  /** saveOtherInspectionDetailResponse method used to handle response */
  saveOtherInspectionDetailResponse(response)
  {
    console.log('saveOtherInspectionDetailResponse '+ response.status);
    if(response.status==="success")  
     {
       this.otherInspectionInfoSaveBtnLbl="Save";
       show_okshan_alert3("Engine sound video is saved");
       slide_up(".inspection-heading");
     }
     else
     {
     this.otherInspectionInfoSaveBtnLbl="Save";  
     show_okshan_alert3(response.reason);     
     } 
  }

  /** sSBDynamicImageChange function used to keep image in list on change */
   otherInspectionEngineSoundVideoChange(event)
   {
      if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.otherInspectionEngineSoundVideoFile=file;              
      }
      else{
      this.otherInspectionEngineSoundVideoFile="";
      }      
   }

   /** loadDocumentXML function used to load steering suspension and break xml */
  loadDocumentXML()
  {
    let result =this.httpserviceService.loadDocumentXMLRequest().
     pipe(retry(0)).
     subscribe((data)=>this.loadDocumentXMLResponse(data).then((data) => {  
           this.documentXML = data;
           this.addInDocumentFrom();  
          }),
     err => {
      //  this.isRequestInprocess=false; 
        show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** loadDocumentXMLResponse function used to handle response */
  loadDocumentXMLResponse(data)
  {    
    console.log('loadDocumentXMLResponse '+ data);
    return new Promise(resolve => {  
      var k: string | number,  
        arr = [],  
        parser = new xml2js.Parser(  
          {  
            trim: true,  
            explicitArray: true  
          });  
      parser.parseString(data, function (err, result) {  
        var obj = result.document;  
        for (k in obj.detail) { 
          var item = obj.detail[k]; 
          //for (m in item.select) {
          var select=item.select[0];
          var labelName=select.name[0];
          var optionList=[];
          for (var m in select.option) {
          var option=select.option[m]
          optionList.push({"id":option.bit[0],"name":option.label[0]});
          }
          var textOption=item.text[0];
          var textType="";
          if(textOption.texttype)
          {
            textType=textOption.texttype   
          }
          var dateMin="";
          var dateMax="";
          if(textOption.texttype=="date")
          {
          dateMin=textOption.datemin;
          dateMax=textOption.datemax;
          }
          //} 
          arr.push({  
            id: item.id[0],  
            name: labelName,  
            text: textType,
            dateMin: dateMin,
            dateMax: dateMax,  
            pic: item.pic[0],
            image: "",
            optionList: optionList  
          });  
        }  
        resolve(arr);  
      });  
    });  
    
  }
   
   /** addInDocumentFrom exterior form from xml */
   addInDocumentFrom()
   {
   for(let i=0;i<this.documentXML.length;i++)
    {
     if(this.documentXML[i].optionList.length==0)
      {
      this.documentDynamicFormGroup.addControl("select_"+this.documentXML[i].id,new FormControl(''));
      }
      else
      {
      this.documentDynamicFormGroup.addControl("select_"+this.documentXML[i].id,new FormControl('',[Validators.required]));
        }
      this.documentDynamicFormGroup.addControl("text_"+this.documentXML[i].id,new FormControl(''));
      if(this.documentXML[i].dateMin)
      {
        if(this.documentXML[i].dateMin=="current")
        {
            setTimeout(() => {
            set_min_date("text_"+this.documentXML[i].id);  
            }, 500);
        }
        if(this.documentXML[i].dateMax=="current")
        {
           setTimeout(() => {
            set_max_date("text_"+this.documentXML[i].id);  
            }, 500);
        } 
      }
    }
    setTimeout(() => {
    this.documentFromStatus=true;  
    }, 200);    
   }

   /** documentDynamicImageChange function used to keep image in list on change */
   documentDynamicImageChange(id,event)
   {
      if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.documentDynamicImages[id]=file;
      console.log('resize before:'+file.size);
        this.ng2ImgMaxService.resize([file], 800, 600).subscribe((result)=>{
        console.log('resize after result:'+result.size);
        this.documentDynamicImages[id]= result; 
        },
        error=> {
          console.log('resize error:',error);
          this.documentDynamicImages[id]=file;
        });
              
      }
      else{
        this.documentDynamicImages[id]="";
      }      
   } 

   /** savedocumentDetail function used to save document detail */
  saveDocumentDetail(data)
  {
    this.isDocumentInfoSubmit=true;    
    if(this.documentDynamicFormGroup.valid)
    { 
     this.documentInfoSaveBtnLbl="Saving";
     const formData = new FormData();
     formData.append("profile_id",this.sessionsService.getSession('id'));
     formData.append("car_id",this.carId);
     for(let i=0;i<this.documentXML.length;i++)
    {
    let id=this.documentXML[i].id;
    formData.append("detail_"+id,this.documentDynamicFormGroup.controls["select_"+id].value+"@#^"+this.documentDynamicFormGroup.controls["text_"+id].value);   
    if(this.documentDynamicImages[id])
    {
    formData.append("detail_"+id+"_pic",this.documentDynamicImages[id]);   
    }
    else
    { 
    formData.append("detail_"+id+"_pic","");   
    }
    }
     let result =this.httpserviceService.saveDocumentDetailRequest(formData).
     pipe(retry(0)).
     subscribe((data)=>this.saveDocumentDetailResponse(data), 
     err => {
       this.documentInfoSaveBtnLbl="Save";
       show_okshan_alert3("Something went wrong !");
       console.log('Something went wrong ', err);       
    })       
  }
  }

  

  /** saveDocumentDetailResponse method used to handle response */
  saveDocumentDetailResponse(response)
  {
    console.log('saveDocumentDetailResponse '+ response.status);
    if(response.status==="success")  
     {
       this.documentInfoSaveBtnLbl="Save";
       show_okshan_alert3("Document detail is saved");
       slide_up(".inspection-heading");
     }
     else
     {
     this.documentInfoSaveBtnLbl="Save";  
     show_okshan_alert3(response.reason);     
     } 
  }
  
  
  
  deletePic(pic){
	var del=confirm("Are you sure you want to delete this image?");
    if (del==true){
		this.httpserviceService.deleteCarpicRequest(pic,this.carId).
		 pipe(retry(0)).
		 subscribe((data)=>this.deletePicResponse(data),
		 err => {
		   alert('Something went wrong');
		   console.log('Something went wrong', err);
		   //this.isLoading=true;
		})    
	}
  }
  
  deletePicResponse(response)
  {
    console.log('deletePicCDResponse '+ response.status);
    if(response.status==="success")  
     {
       alert("This image is deleted"); 
	   window.location.reload();  
     }
     else
     {
     alert(response.reason);
     //this.isLoading=true;
     } 
  }
  
  /** selectProfilePic function used to select profile pic */
  selectProfilePic(event) {    
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.selectedProfilePic= file;
      //});
    }
    else{
       this.selectedProfilePic="";
    }
  }
  
  editPic(key){
	var del=confirm("Are you sure you want to upload this image?");
    if (del==true){	
		let formData=new FormData();
		formData.append(key,this.selectedProfilePic);
		formData.append("car_id",this.carId);
		this.httpserviceService.editCarpicRequest(formData).
		 pipe(retry(0)).
		 subscribe((data)=>this.editPicResponse(data),
		 err => {
		   alert('Something went wrong');
		   console.log('Something went wrong', err);
		   //this.isLoading=true;
		})    
	}
  }
  
  editPicResponse(response)
  {
    console.log('editPicCDResponse '+ response.status);
    if(response.status==="success")  
     {
       alert("This image is Uploaded"); 
	   window.location.reload();  
     }
     else
     {
     alert(response.reason);
     //this.isLoading=true;
     } 
  }

  checkImages()
  {
    
    if(this.tp > 3)  
     {
       alert("Submitted succesfully"); 
     }
     else
     {
		alert("Please submit atleast 4 images");
     //this.isLoading=true;
     } 
  }
}
